<template>
    <button class="pp-button" 
        :class="{
            'is-round': round, 
            'is-circle': circle, 
            'is-plain': plain, 
            'is-disabled': disabled || loading,
        }"
        :type="type" :size="size" :disabled="disabled"
        @click="click">
        <i v-if="loading" class="pp-button__loading pp-icon-loading"></i>
        <i v-if="icon && !loading" :class="icon"></i>
        <span v-if="$slots.default">
            <slot></slot>
        </span>
    </button>
</template>

<script>
/**
 * 按钮
 * @param {string} type 按钮风格[default, primary, success, warning, info]
 * @param {string} size 尺寸[normal, small, mini]
 * @param {string} icon 图标(可用ui定义好的pp-icon-*, 也可以用iconfont icon-*)
 * @param {boolean} plain 简单样式模式
 * @param {boolean} round 圆角图标
 * @param {boolean} circle 圆图标
 * @param {boolean} disabled 禁用状态
 * @param {boolean} loading 加载状态
 * @event click 点击事件 参数:event
 */
export default {
    name: 'pp-button',
    props: {
        type: {
            type: String,
            default: 'default',
        },
        size: {
            type: String,
            default: 'normal',
        },
        icon: String,
        plain: Boolean,
        round: Boolean,
        circle: Boolean,
        disabled: Boolean,
        loading: Boolean,
    },
    methods: {
        click: function(e) {
            !this.loading && this.$emit('click', e)
        },
    },
}
</script>

<style>

</style>
